export const visit = (vm, at) => {
vm(require("./availability/th.lyaml"));
vm(require("./typical-response-time/th.lyaml"));
vm(require("./default/th.lyaml"));
at({ "th": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "\u0E15\u0E01\u0E25\u0E07" } } });
};